/*
 * @Descripttion:
 * @version:
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-06-30 11:14:14
 * @LastEditors: linxi
 * @LastEditTime: 2025-09-12 10:21:26
 */
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Col,
  Form,
  Input,
  notification,
  Radio,
  Row,
} from 'antd'
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../../app/store'
import styles from '../../functionSettingTabs.module.css'
import _ from 'lodash'
import { Checks, Settinglable, Settings } from '../../../../models/setting'
import { getSettingDetail, saveSettingLabel, selectSettings, selectTenant } from '../../../user/setting/settingSlice'
import { Tenant } from '../../../../models/tenant'
import { PayMethod } from '../../../../models/payment'
import { setSettings } from '../../../settings/settingsSlice'

export const NurseStationSettings = (props: {
  selectedTab: any
}): ReactElement => {
  const [form] = Form.useForm()

  const settings = useSelector(selectSettings)

  const tenant = useSelector(selectTenant)

  const dispatch = useDispatch<RootDispatch>()

  const [buttonLoading, setButtonLoading] = useState(false)

  useEffect(() => {
    if (props?.selectedTab == '9') {
      dispatch(getSettingDetail())
    }
  }, [props?.selectedTab])

  useEffect(() => {
    if (props?.selectedTab == '9') {
      if (tenant) {
        form.setFieldsValue({
          ...tenant,
          registeredFund: null,
        })
      }
      if (settings) {
        const defaultMethod =
          (parseInt(settings[Checks.Mrzffs]) as PayMethod) || PayMethod.Cash
        dispatch(
          setSettings({
            [Settings.Treatment.DoNotWarnDoctorMismatch]:
              settings[Checks.Gbkdysstx] || false,
            [Settings.Treatment.Settlement]: settings[Checks.Zjjs] || false,
            [Settings.Recipe.ChangePrice]: !(settings[Checks.Gbxgjg] || false),
            [Settings.Payment.DefautMethod]: defaultMethod,
            [Settings.Recipe.AutoChangePrice]: settings[Checks.ZDJSTS] || false,
            [Settings.Recipe.AutoChangePriceAfter]:
              settings[Checks.ZDJSTSBCH] || false,
          })
        )
        const KZXSJValue = settings[Checks.KZXSJ]
        form.setFieldsValue({
          ...settings,
          [Checks.KZXSJ]: KZXSJValue || '3'
        })
      }
    }
  }, [tenant, settings, props?.selectedTab])

  return (
    <Col className={styles.AISetting}>
      <Form
        form={form}
        onFinish={(values) => {
          const pattern = /^[0-9]*$/

          const t = _.chain(values)
            .omitBy((_, k) => pattern.test(k))
            .value() as Tenant

          const f = _.chain(values)
            .pickBy((_, k) => pattern.test(k))
            .mapValues(
              (v, k) =>
              ({
                type: k,
                value: v?.toString(),
              } as Settinglable)
            )
            .values()
            .value()
          setButtonLoading(true)
          dispatch(
            saveSettingLabel({
              tenant: {
                ...tenant,
                ...t,
              },
              functionList: f,
            })
          )
            .then(unwrapResult)
            .then(() => {
              notification.success({
                message: '保存成功,部分配置需要重新登陆后生效',
                duration: 3,
              })
              dispatch(getSettingDetail())
            })
            .catch(() => {
              notification.error({ message: '机构设置保存失败', duration: 3 })
              dispatch(getSettingDetail())
            })
            .finally(() => {
              setButtonLoading(false)
            })
        }}
      >
        <div style={{ overflow: 'auto', height: 'calc(100% - 40px)' }}>
          <div>
            <Col className={styles.rowHeight} span={24}>
              <Form.Item label='可执行时机' name={Checks.KZXSJ}>
                <Radio.Group defaultValue={'3'}>
                  <Radio value={'1'}>开单后即可执行（包含未收费）</Radio>
                  <Radio value={'2'}>收费后才可执行</Radio>
                  <Radio value={'3'}>不开启处方执行</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </div>
        </div>
        <Row style={{ paddingTop: '10px' }}>
          <Col span={12}>
            <Button
              htmlType='button'
              onClick={() => {
                dispatch(getSettingDetail())
              }}
              style={{
                float: 'right',
                marginRight: '10px',
              }}
            >取消
              
            </Button>
          </Col>
          <Col span={12}>
            <Button
              loading={buttonLoading}
              type='primary'
              htmlType='submit'
              style={{
                float: 'left',
              }}
            >
              保存
            </Button>
          </Col>
        </Row>
      </Form>
    </Col >
  )
}
